<template>
  <div>
    <div class="d-flex justify-space-between bg-orange-lighten-3 px-3 py-2 rounded-t shadowed mt-1">
      <div class="text-h6">{{ commande.module.nom }} | Commande n°{{ commande.uuid }} | ID. {{ commande.id }}</div>
      <div class="text-body">{{ $moment(commande.timestamp).format("DD/MM/YYYY à HH:mm") }}</div>
    </div>

    <div class="bordered rounded-b bg-grey_1 mb-3 px-3 pb-3">
      <div class="d-flex gap mt-3">
        <InformationsPaiement :commande="commande"></InformationsPaiement>
        <ListTransactions v-if="commande.list_transactions.length > 0" :transactions="commande.list_transactions">
        </ListTransactions>
      </div>
      <v-btn class="mt-3" size="small" @click="send_email_confirm_client()">Renvoyer le mail de confirmation de
        commande</v-btn>
      <div v-for="commande_inscriptions in commande.list_commandes_inscriptions_coureur"
        :key="commande_inscriptions.id">
        <v-sheet class="mt-3" border elevation="0">
          <div class="text-h5 mb-3 pa-2 bg-lightblue">Commande inscriptions | ID. {{ commande_inscriptions.id }}</div>
          <div class="d-flex sm-gap pa-2">
            <v-chip size="small" color="dark">Inscription {{ commande_inscriptions.type }}</v-chip>
            <v-chip size="small" color="dark">Prix {{ commande_inscriptions.prix }}€</v-chip>
            <v-chip size="small" color="dark"> {{ commande_inscriptions.inscriptions.length }} inscription(s)
              associée(s)</v-chip>
            <v-chip size="small" color="green-darken-4" v-if="commande_inscriptions.valide == '1'"><v-icon
                icon="mdi-check"></v-icon> Payée</v-chip>
            <v-chip size="small" color="deep-orange-darken-4" v-else><v-icon icon="mdi-close"></v-icon> Non
              payée</v-chip>
          </div>
          <div class="d-flex flex-column gap mt-1 pa-2">
            <InformationInscription v-for="inscription in commande_inscriptions.inscriptions" :inscription="inscription"
              :key="inscription.id"></InformationInscription>
          </div>
          <div class="d-flex flex-column gap mt-1 pa-2" v-if="commande_inscriptions.list_commandes_options.length > 0">
            <InformationOptions :options="commande_inscriptions.list_commandes_options"></InformationOptions>
          </div>
          <div class="d-flex flex-column gap mt-1 pa-2" v-if="commande_inscriptions.gia">
            <InformationGIA :gia="commande_inscriptions.gia"></InformationGIA>
          </div>
          <div class="d-flex flex-column gap mt-1 pa-2" v-if="commande_inscriptions.donation">
            <InformationDonation :donation="commande_inscriptions.donation"></InformationDonation>
          </div>
          <div class="d-flex flex-column gap mt-1 pa-2" v-if="commande_inscriptions.code_reduction">
            <InformationCodeReduction :code_reduction="commande_inscriptions.code_reduction"></InformationCodeReduction>
          </div>
        </v-sheet>
      </div>
      <div class="text-h5 mt-2 pa-2">Actions</div>
      <div class="d-flex flex-wrap gap">
        <v-card class="bg-white" v-if="commande.statut != 'PAID'">
          <template v-slot:title>Supprimer cette commande</template>
          <template v-slot:actions>
            <v-btn color="primary-dark" text>Supprimer</v-btn>
          </template>
        </v-card>
        <v-card class="bg-white" v-if="commande.statut != 'PAID' && mainStore.authAdmin.hasSuperAdminRights">
          <template v-slot:title>Indiquer la commande comme payée</template>
          <template v-slot:actions>
            <v-btn color="primary-dark" text @click="set_status_paid()">Passer à PAID</v-btn>
          </template>
        </v-card>
        <v-card class="bg-white" v-if="commande.statut == 'PAID' && mainStore.authAdmin.hasSuperAdminRights">
          <template v-slot:title>Indiquer la commande comme non payée</template>
          <template v-slot:actions>
            <v-btn color="primary-dark" text @click="set_status_unpaid()">Passer à UNPAID</v-btn>
          </template>
        </v-card>
        <v-card class="bg-white" v-if="commande.statut != 'PAID'">
          <template v-slot:title>Génerer un lien de paiement</template>
          <template v-slot:actions>
            <v-btn color="primary-dark" text @click="generate_payment_link()">Copier le lien</v-btn>
          </template>
        </v-card>
        <v-card class="bg-white" v-if="commande.statut != 'PAID'">
          <template v-slot:title>[SANCY] Mail avec lien de paiement</template>
          <template v-slot:actions>
            <v-btn color="primary-dark" text @click="send_mail_with_payment_link()">Envoyer le mail</v-btn>
          </template>
        </v-card>
        <v-card class="bg-white" v-if="commande.statut == 'PAID'">
          <template v-slot:title>Génerer un lien de connexion</template>
          <template v-slot:actions>
            <v-btn color="primary-dark" @click="generate_connexion_link()" text>Copier le lien</v-btn>
          </template>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";

import AdminService from "@/services/admin.service.js";
import axios from "axios";
import InformationsPaiement from "./Informations_Paiement.vue";
import ListTransactions from "./List_Transactions.vue";
import InformationInscription from "./Information_Inscription.vue";
import InformationOptions from "./Informations_Options.vue";
import InformationCodeReduction from "./Informations_Code_Reduction.vue";
import InformationGIA from "./Informations_GIA.vue";
import InformationDonation from "./Informations_Donation.vue";

export default {
  components: {
    InformationsPaiement,
    ListTransactions,
    InformationInscription,
    InformationOptions,
    InformationCodeReduction,
    InformationGIA,
    InformationDonation,
  },
  props: ["commande"],
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async set_status_paid() {
      let request = await AdminService.setCommandeStatus(this.commande.uuid, "paid");
      if (request) {
        this.mainStore.notification.send("Statut de la commande modifié avec succès", "success");
        this.$emit("change_status");
      }
      else {
        this.mainStore.notification.send("Erreur lors de la modification du statut de la commande", "error");
      }
    },
    async set_status_unpaid() {
      let request = await AdminService.setCommandeStatus(this.commande.uuid, "unpaid");
      if (request) {
        this.mainStore.notification.send("Statut de la commande modifié avec succès", "success");
        this.$emit("change_status");
      }
      else {
        this.mainStore.notification.send("Erreur lors de la modification du statut de la commande", "error");
      }
    },

    async send_email_confirm_client() {
      let request = await AdminService.sendConfirmationEmail(this.commande.uuid);
      if (request) {
        this.mainStore.notification.send("Email envoyé avec succès", "success");
      }
      else {
        this.mainStore.notification.send("Erreur lors de l'envoi de l'email", "error");
      }
    },

    async generate_connexion_link() {

      let request = await AdminService.generateLoginLink(this.commande.id_account);
      if (request) {
        navigator.clipboard.writeText("https://sportips.fr/inscription/" + this.mainStore.module.base + "/fiche?auth=" + request.crypted_id);
        this.mainStore.notification.send("Lien copié dans le presse-papier", "success");
      }
      else {
        this.mainStore.notification.send("Erreur lors de la génération du lien", "error");
      }
    },

    async send_mail_with_payment_link() {

      let res = await axios.post("/administration/commande/send_mail_with_payment_link.php", { uuid: this.commande.uuid });
      if (res.data.error) {
        console.log(res.data.error);
        return await false;
      } else {
        return await true;
      }
    },
    async generate_payment_link() {
      let request = await AdminService.generatePaymentLink(this.commande.uuid);
      if (request) {
        navigator.clipboard.writeText("https://sportips.fr/inscription/" + this.mainStore.module.base + "/resend-payment?c=" + request.crypted_uuid);
        this.mainStore.notification.send("Lien copié dans le presse-papier", "success");
      }
      else {
        this.mainStore.notification.send("Erreur lors de la génération du lien", "error");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>